<template>
    <div class="event-preview-wrapper" v-if="eventInfo">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div :style="backgroundImage" class="event-img"></div>
        <div class="head-info">
            <div class="event-info">
                <div class="event-date">
                    <span class="event-date-text">{{ eventInfo.start_date }}</span>
                </div>
                <div class="event-title-name">
                    <div class="event-name-with">
                        <div class="event-name-text">{{ eventInfo.title }} with</div>

                        <span
                            v-for="(artists, index) in artistInfo"
                            :key="artists.id"
                            class="event-name-text"
                            >{{ artists.band_name }}
                            <span v-if="index < artistInfo.length - 1">&amp;</span>
                        </span>
                    </div>
                    <span class="event-descr-text">{{ eventInfo.description }}</span>
                    <div class="featuring-artists">
                        <span class="featuri">Featuring</span>
                        <div class="featuring-artists-container">
                            <div
                                class="artist-tag"
                                v-for="(artists, id) in artistInfo"
                                :key="id"
                            >
                                <img
                                    :src="fixDoubleSlashes(artists.avatar)"
                                    alt="/"
                                    class="artist-avatar-small img-fluid"
                                />
                                <a
                                    :href="'/artists/' + artists.slug"
                                    target="_blank"
                                    class="event-descr-text"
                                    >{{ artists.band_name }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="venue-adress">
                    <p class="event-name-text">
                        at
                        {{
                            eventInfo.venue_name ? eventInfo.venue_name : venueInfo.venue_name
                        }}
                    </p>
                    <div class="d-flex align-items-center">
                        <img
                            src="/images/icons/social/Verticalcontainer.svg"
                            alt="/"
                            class="addr-img"
                        />
                        <span class="venue-adress-text px-2">
                            At {{ eventInfo.address ? eventInfo.address : venueInfo.address }}
                        </span>
                    </div>
                    <div class="event-doors">
                        <span v-if="eventInfo.start_time" class="featuri"
                            >Doors at {{ eventInfo.start_time }}</span
                        >
                        <span v-if="eventInfo.cover_cost" class="featuri"
                            >${{ Math.round(eventInfo.cover_cost) }} cover</span
                        >
                        <span v-if="eventInfo.min_age" class="featuri"
                            >{{ eventInfo.min_age }}+</span
                        >
                    </div>
                    <div class="event-vibe">
                        <span class="event-descr-text">Vibe: {{ eventInfo.vibe }}</span>
                    </div>
                </div>
                <!--@TODO: after discuss with Dastan, I hid buttons, because we don't have functionality-->
                <div class="event-btns d-none">
                    <button class="calendar-btn">
                        <span class="calendar-btn-text">Add to Calender</span>
                    </button>
                    <button class="share-btn">
                        <span class="share-btn-text">Share</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="additional-event-info">
            <div class="feat-info">
                <span class="add-info-header">Featuring</span>
                <ArtistCard
                    v-for="(artist, index) in artistInfo"
                    :key="index"
                    :artistInfo="artist"
                />
            </div>
            <div class="feat-info" v-if="relatedEvents.length">
                <span class="add-info-header">More Shows at {{ venueInfo.venue_name }}</span>
                <event-card :relatedEvents="relatedEvents"></event-card>
            </div>
            <div class="feat-info">
                <span class="add-info-header">
                    About
                    {{ eventInfo.venue_name ? eventInfo.venue_name : venueInfo.venue_name }}
                </span>
                <venue-info :media="media" :venueInfo="venueInfo"></venue-info>
            </div>
            <div class="feat-info" v-if="media.length">
                <span class="add-info-header">Media</span>
                <carousel
                    class="align-center"
                    :mediaList="media"
                    :options="carouselStyle"
                    @currentMediaIndx="updateCurrentMediaIndx"
                ></carousel>
            </div>
        </div>
    </div>
</template>
<script>
    import ArtistCard from './events-parts/ArtistCard.vue'
    import EventCard from './events-parts/EventCard.vue'
    import VenueInfo from './events-parts/VenueInfo.vue'
    import Carousel from '../../../ui/carousels/Carousel.vue'
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import useCheckScreen from '@/composables/useCheckScreen'

    export default {
        name: 'EventPreviewPage',
        components: {
            ArtistCard,
            EventCard,
            VenueInfo,
            Carousel
        },
        setup() {
            const { isMobile } = useCheckScreen()
            return { isMobile }
        },
        data: () => ({
            carouselOptions: {
                index: 0,
                style: {
                    currentMedia: {
                        width: 260,
                        height: 260
                    },

                    otherMedia: {
                        width: 220,
                        height: 220
                    },

                    actionBtns: {
                        Xoffset: 200,
                        Yoffset: 180,
                        twoMediaXoffSet: 100
                    }
                }
            },
            eventId: null,
            eventInfo: null,
            artistInfo: null,
            venueInfo: null,
            relatedEvents: null,
            media: null,
            load: false
        }),
        computed: {
            backgroundImage: (self) => {
                const bgImage = encodeURI(
                    self.eventInfo.image || self.media[0].src || '/images/global/default.png'
                )
                return {
                    'background-image': `linear-gradient(to left, transparent 50%, #121212 100%), linear-gradient(to bottom, transparent 50%, #121212 100%), url(${bgImage})`
                }
            },
            carouselStyle: (self) => {
                if (self.isMobile) {
                    return {
                        ...self.carouselOptions.style,
                        container: {
                            'margin-left': 'auto',
                            'margin-right': 'auto'
                        }
                    }
                } else {
                    return self.carouselOptions.style
                }
            }
        },
        methods: {
            async fetchEventData() {
                this.load = true
                try {
                    const isPreview = window.location.pathname.includes('/event/show-preview/')

                    const previewParam = isPreview ? '?preview=true' : ''

                    const resp = await axios.get(
                        `/api/event/publish-event/${this.eventId}${previewParam}`
                    )
                    this.eventInfo = resp.data.event
                    this.artistInfo = resp.data.responded_artist
                    this.relatedEvents = resp.data.related_events
                    this.venueInfo = resp.data.venue
                    this.media = resp.data.venue_media
                    this.load = false
                } catch (e) {
                    this.load = false
                    notification('error', e)
                }
            },
            getIdFromUrl() {
                const url = window.location.href
                this.eventId = url.split('/').at(-1)
            },
            updateCurrentMediaIndx(indx) {
                this.carouselOptions.index = indx
            },
            fixDoubleSlashes(path) {
                return path.replace(/([^:]\/)\/+/g, '$1')
            }
        },
        async created() {
            await this.getIdFromUrl()
            await this.fetchEventData()
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .featuring-artists-container {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }
    .featuring-artists-container::-webkit-scrollbar {
        width: 0;
    }
    .event-preview-wrapper {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        padding: 150px 0 100px 90px;
        background: #121212;
    }
    .head-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        flex: 1;
        position: relative;
    }
    .event-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        width: 40%;
        flex: 1;
        z-index: 50;
    }
    .event-date-text {
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 56px;
        font-style: normal;
        font-weight: 450;
        line-height: 100%;
        letter-spacing: -2.24px;
    }
    .event-name-with {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        gap: 5px;
    }
    .event-name-text {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin: 0;
    }
    .featuring-artists {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }
    .event-descr-text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: pre-line;
        max-width: 620px;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        text-decoration: none;
    }
    .featuri {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .venue-adress {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    .venue-adress-text {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .event-img {
        display: flex;
        flex-basis: 60%;
        height: 748px;
        background-repeat: no-repeat;
        background-size: cover;
        width: 923px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 0;
    }
    .event-title-name {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        gap: 8px;
    }
    .addr-img {
        width: 20px;
        height: 20px;
    }
    .artist-avatar-small {
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }
    .artist-tag {
        display: flex;
        padding: 5px 12px 5px 5px;
        align-items: center;
        gap: 10px;
        border-radius: 100px;
        border: 1px solid #acacac;
        background: #121212;
        min-width: max-content;
    }
    .event-doors {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .event-btns {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
    }
    .calendar-btn {
        display: flex;
        min-width: 200px;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border: none;
        border-radius: 100px;
        background: #cdeb09;
    }
    .share-btn {
        display: flex;
        width: 200px;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: #121212;
        min-width: 200px;
    }
    .calendar-btn-text {
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .share-btn-text {
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .additional-event-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 80px;
        margin-top: 100px;
    }
    .feat-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 32px;
        align-self: stretch;
        z-index: 50;
    }
    .add-info-header {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.76px;
    }
    .media-wrapper {
        align-items: center;
        display: flex;
        flex-direction: column;
    }
    @media (max-width: 600px) {
        .featuring-artists-container {
            overflow-y: scroll;
            max-width: 360px;
            flex-wrap: nowrap;
        }
        .featuring-artists-contain::-webkit-scrollbar {
            width: 0;
        }
        .event-date-text {
            font-size: 44px;
        }
        .event-preview-wrapper {
            padding: 16px;
        }
        .event-btns {
            flex-direction: column;
            width: 100%;
        }
        .calendar-btn {
            width: 100%;
        }
        .share-btn {
            width: 100%;
        }
        .head-info {
            position: relative;
            margin-top: 400px;
        }
    }
</style>
